import { render, staticRenderFns } from "./lxu-test.vue?vue&type=template&id=469caa86"
import script from "./lxu-test.vue?vue&type=script&lang=js"
export * from "./lxu-test.vue?vue&type=script&lang=js"
import style0 from "./lxu-test.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports